import PipelineSiteContainer from './PipelineSiteTableContainer';

export default PipelineSiteContainer;
